<template>
    <div>
      <b-row>
        <b-col>
          <md-field>
            <b-input v-model="filter" @update="filterChanged" @keypress="currentPage = 1"></b-input>
          </md-field>
        </b-col>
      </b-row>

      <basic-table
        v-if="AccountsItem"
        :items="AccountsItem"
        :fields="AccountsFields"
        :filter="filter"
        :perPage="perPage"
        @ClickOnEditButton="onRowDoubleClick"
        @SortCallBack="sortChanged"
        isEdit="false"
        isDelete="false"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
  </template>

<script>
export default {
  data () {
    return {
      getStore: {
        currentPage: 1,
        perPage: 35,
        filter: '',
        sortField: '',
        isDesc: 0
      },
      selectedAccounts: null,
      AccountsItem: [],
      AccountsFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true}
      ],
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 35,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    sortChanged (ctx) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      this.getStore.sortField = ctx.sortBy
      this.getStore.isDesc = ctx.sortDesc ? 1 : 0
      this.$store.dispatch('Users/GET_ACCOUNTS_LIST', this.getStore)
    },
    onRowDoubleClick (item, index, event) {
      this.$emit('AccountSelected', item)
    },
    filterChanged (value) {
      this.currentPage = 1
      this.getStore.filter = value
      this.getStore.currentPage = 1
      this.$store.dispatch('Users/GET_ACCOUNTS_LIST', this.getStore)
    }
  },
  watch: {
    Accounts: function (val) {
      this.AccountsItem = JSON.parse(JSON.stringify(val.users))
      this.totalRows = val.total_rows
    },
    currentPage: function (val) {
      this.getStore.currentPage = val
      this.$store.dispatch('Users/GET_ACCOUNTS_LIST', this.getStore)
    }
  },
  mounted () {

  },
  computed: {
    Accounts () {
      return this.$store.getters['Users/ACCOUNTS_LIST']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accountsGroups/accounts.vue